module.exports = __webpack_public_path__ + "45465e27194270b2ef1bd5d1ed92d200.jpg";